import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/onboarding/Onboarding.css';

const OnboardingBottomNav = ({ onBack, onNext, nextDisabled = false, nextLabel = 'Next', backLabel = 'Back' }) => {
  return (
    <div className="onboarding-bottom-nav">
      <button 
        className="onboarding-back-button"
        onClick={onBack}
      >
        {backLabel}
      </button>
      
      <button 
        className="onboarding-next-button"
        onClick={onNext}
        disabled={nextDisabled}
      >
        {nextLabel}
      </button>
    </div>
  );
};

OnboardingBottomNav.propTypes = {
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  nextDisabled: PropTypes.bool,
  nextLabel: PropTypes.string,
  backLabel: PropTypes.string
};

export default OnboardingBottomNav;